import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { da } from 'primelocale/da.json';
import { colorPalettes } from 'src/theme/color-palettes';
import divider from 'src/theme/primeng-designtokens/divider';
import progressspinner from 'src/theme/primeng-designtokens/progressspinner';
import accordion from './primeng-designtokens/accordion';
import button from './primeng-designtokens/button';
import card from './primeng-designtokens/card';
import datatable from './primeng-designtokens/datatable';
import drawer from './primeng-designtokens/drawer';
import panelmenu from './primeng-designtokens/panelmenu';
import tabs from './primeng-designtokens/tabs';
import tag from './primeng-designtokens/tag';
import toolbar from './primeng-designtokens/toolbar';
import tooltip from './primeng-designtokens/tooltip';

// Aura's default dark text color is pure white ({surface.0}) on a near-black
// background, which is a ~18:1 contrast ratio — technically high-contrast but
// harsh/tiring to read. Dim it to 87% white.
// 87% is the default text color for Material Design dark themes (consider it as field standard for dark themes)
const DARK_TEXT_COLOR = 'rgba(255, 255, 255, 0.87)';

const CustomPrimeNGPreset = definePreset(Aura, {
  primitive: colorPalettes,
  components: {
    progressspinner,
    divider,
    tag,
    datatable,
    tabs,
    toolbar,
    drawer,
    panelmenu,
    card,
    tooltip,
    accordion,
    button,
  },
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
    colorScheme: {
      dark: {
        text: {
          color: DARK_TEXT_COLOR,
          hoverColor: DARK_TEXT_COLOR,
        },
      },
    },
  },
});

export const primengConfig = {
  translation: da,
  theme: {
    preset: CustomPrimeNGPreset,
    options: {
      darkModeSelector: '.dark',
      cssLayer: {
        name: 'primeng',
        order: 'theme, base, components, primeng, utilities',
      },
    },
  },
};
